import { Component } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Message, MessageTypes } from './message';
import { MessageService } from './message.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
import {MenuService} from './menu/menu.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent {
    public MessageTypes = MessageTypes;
    public message;
    public messageType;
    public messageText;
    public forceMenu = false;
    title = 'app';
    constructor (
        public authentication: AuthenticationService,
        private messageService: MessageService,
        public snackBar: MatSnackBar,
        protected menuService: MenuService
    ) {
        // this.messageService.setMessage('', MessageTypes.None);
        this.messageService.message.subscribe((message) => {
            this.messageType = message.type; this.messageText = message.text;
            if (message.text !== '') {
                this.showSnackBar(message.text); // todo: either get rid of the message type or use it somehow
            }
        });
        this.menuService.addMenuItems(
            [
                {
                    name: 'dashboard',
                    path: '/dashboard',
                    icon: 'fas fa-columns'
                }
                ],
            false
        );
    }
    public showSnackBar(message: string) {
        this.snackBar.open(message, '', {duration: 4000});
    }
    get type() {
        return this.messageType;
    }
    get text() {
        return this.messageText;
    }
    public closeMessage() {
        this.messageService.clearMessage();
    }
    public toggleMenu() {
        this.forceMenu = !this.forceMenu;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts